/** Persisted after user chooses "Continue as guest" on the welcome screen. */
const STORAGE_KEY = "dripwatch-welcome-continued-v1";

export function hasWelcomeContinued(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(STORAGE_KEY) === "1";
}

export function setWelcomeContinuedAsGuest(): void {
  localStorage.setItem(STORAGE_KEY, "1");
}

export function clearWelcomeContinued(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
}
